import axios from 'axios';
import React, { useEffect, useRef, useState } from 'react';
import { BACKEND_URL, FEDAPAY_PUBLIC_KEY } from "../config";
import { useTranslation } from 'react-i18next';


const Fedapay = ({item, options,onSuccess}) => {
    const flag = useRef(false);
    const [widget, setWidget] = useState();
     const { t, i18n } = useTranslation();
    

    
    useEffect(() => {
        const initialize = async () => {
            const id_currency = options['id_currency'];
            let success_url = options['success_url'];
            const description = options['description'] ?? `Paiement pour ${item['name']} via Fedapay`;
            let amountXof = options['amount'];
           
           
            if(id_currency !== 3)
            {
                await axios.get(`${BACKEND_URL}get/conversion/${id_currency}`)
                .then(response => amountXof = Math.round(item['price'] * response.data.currency.value_to_xof))
            }
            const FedaPayApi = window['FedaPay'];
            if(!FedaPayApi)
                throw new Error('Impossible de charger Fedapay')
                
            const init = FedaPayApi.init({
                public_key: FEDAPAY_PUBLIC_KEY,
                transaction: {
                    amount: amountXof,
                    description: description
                },
                
                customer: {
                email: options.customer.email,
                lastname: options.customer.last_name,
                firstname: options.customer.first_name,
                phone_number: {
                    number: options.customer.phone,
                    country: options.customer.code_country.toUpperCase()
                },
               
                },
                
                onComplete: function (data) {
                    if (data.reason === 'CHECKOUT COMPLETE' && data.transaction.status === 'approved') {
                        let tab = success_url.split('?');
                        success_url= tab[0];
                        let query= tab[1] ?? '';
                        if(query.length >0) query +='&';
                        onSuccess(2,data.transaction.id,options['id_currency'])
                       
                        query += 'provider=2&paymentId=' +data.transaction.id +'&id_currency='+ id_currency;
                        //  localStorage.setItem('provider',2);
                        // localStorage.setItem('paymentId',data.transaction.id);
                        // localStorage.setItem('id_currency',options['id_currency']);
                        
                        //window.location = success_url +'?' + query;
                    }else{
                        console.log(data);
                    }
                }
            });
            setWidget(init)           
        }
        if(flag.current === false)
        {
            initialize()
        }

        return () => flag.current = true
    }, [])

    const handle = () => {
        if(widget)
            widget.open()
    }
    
    return (
        <button 
            onClick={() => handle()}
            className="text-white bg-green-600 hover:bg-green-700 px-4 py-3 rounded-lg text-center w-[300px] mx-auto block font-medium transition-colors duration-200 shadow-md hover:shadow-lg flex items-center justify-center mt-4"
           >
        <span className="mr-2">📱</span> {t("Mobile Money")}
      </button>
    );
};

export default Fedapay;